import state from "./moduleChildlinkageState.js";
import mutations from "./moduleChildlinkageMutations.js";
import actions from "./moduleChildlinkageActions.js";
import getters from "./moduleChildlinkageGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
